// extracted by mini-css-extract-plugin
export default {"questionContainer":"question_questionContainer__V-XGJ","icon":"question_icon__OscaU"};